// src/components/shared/Hero.jsx
import React from 'react';

// Util p/ resolver caminho mesmo se o app estiver num subpath
const resolveSrc = (raw) => {
  if (!raw) return '';
  // já é http(s)?
  if (/^https?:\/\//i.test(raw)) return raw;

  // base CRA / Vite
  const base =
    (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.BASE_URL) ||
    (typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL) ||
    '/';

  // normaliza barras
  const cleanBase = base.endsWith('/') ? base : `${base}/`;
  const cleanRaw = raw.startsWith('/') ? raw.slice(1) : raw;

  return `${cleanBase}${cleanRaw}`;
};

const Hero = ({
  title = 'Validação de Faturas',
  subtitle = 'finance@invoices.martinscastro.pt',
  icons = [],
}) => {
  // Normaliza: permite ['path.png', {src, alt, effect}]
  const normalized = icons.map((it) =>
    typeof it === 'string' ? { src: it, alt: 'icon', effect: 'pendulum' } : it
  );

  return (
    <header
      className="relative overflow-hidden text-white py-8 lg:py-12 w-full"
      style={{ background: 'linear-gradient(135deg, rgb(129, 41, 156) 0%, rgb(158, 51, 189) 100%)' }}
    >
      {/* onda decorativa */}
      <div
        className="absolute bottom-0 left-0 w-full h-16 lg:h-24 opacity-10"
        style={{
          background:
            "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320'%3E%3Cpath fill='%23ffffff' fill-opacity='1' d='M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,138.7C960,139,1056,117,1152,101.3C1248,85,1344,75,1392,69.3L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z'%3E%3C/path%3E%3C/svg%3E\") 0% 0% / cover",
          animation: 'wave 10s linear infinite',
        }}
      />
      <style>{`
        @keyframes wave { from { background-position-x: 0; } to { background-position-x: 1440px; } }
        @keyframes iconPendulum { 0% { transform: rotate(6deg) } 50% { transform: rotate(-6deg) } 100% { transform: rotate(6deg) } }
        @keyframes iconRotate { 0% { transform: rotate(0deg) } 100% { transform: rotate(360deg) } }
      `}</style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col lg:flex-row justify-between items-center gap-6">
          <div className="text-center lg:text-left">
            <h1 className="text-2xl sm:text-3xl lg:text-3xl font-extrabold tracking-tight mb-2">
              {title}
            </h1>
            <p className="text-base lg:text-lg opacity-90">{subtitle}</p>
          </div>

          <div className="flex items-center gap-4 lg:gap-6 scale-75 sm:scale-90 lg:scale-100">
            {normalized.map((icon, idx) => {
              const effect =
                icon.effect === 'rotate' ? 'iconRotate 40s linear infinite'
                : 'iconPendulum 40s ease-in-out infinite';
              const src = resolveSrc(icon.src);
              return (
                <div
                  key={`${icon.src}-${idx}`}
                  className="transition-all duration-500 hover:scale-105"
                  style={{ animation: effect }}
                >
                  <img
                    alt={icon.alt || 'Icone'}
                    className="w-20 h-20 object-contain filter drop-shadow-lg hover:scale-110 transition-transform duration-300"
                    src={src}
                    onError={(e) => {
                      // feedback visual se 404
                      e.currentTarget.style.opacity = '0.3';
                      e.currentTarget.title = `Não foi possível carregar: ${src}`;
                    }}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Hero;
